// extracted by mini-css-extract-plugin
export var standaloneTable = "_en-0";
export var standaloneTableWithBodyFill = "_en-1";
export var withExtraHeader = "_en-2";